import React from "react";
import { connect } from "react-redux";
import NotificationItem from "./_NotificationItem";
import CustomScroll from "react-custom-scroll";

const Notifications = props => (
  <div
    className={"notifications" + (props.SidebarHiding ? " hiding" : "")}
    onClick={props.handleNotifications}
  >
    <div
      className={
        "notifications-wrapper" + (props.SidebarHiding ? " hiding" : "")
      }
      onClick={e => e.stopPropagation()}
    >
      <button className="btn btn-close" onClick={props.handleNotifications}>
        <i className="icon-omni-close-circle" />
      </button>
      <h3>{props._.Notifications}</h3>
      {props.Notifications && props.Notifications.length > 0 ? (
        <div className="text-right">
          <button
            className="btn-clear"
            onClick={() =>
              props.DeleteNotificationsById(props.Notifications.map(n => n.id))
            }
          >
            <i className="icon-omni-delete" /> {props._.ClearAll}
          </button>
        </div>
      ) : (
        <div className="empty-state">
          <p>{props._.NoNotificaions}</p>
        </div>
      )}
      <CustomScroll heightRelativeToParent="100%" allowOuterScroll={true}>
        <div className="notifications-list">
          {props.Notifications.map((notification, key) => (
            <NotificationItem
              Notification={notification}
              key={notification.id}
              _={props._}
              DeleteNotificationsById={props.DeleteNotificationsById}
            />
          ))}
        </div>
      </CustomScroll>
    </div>
  </div>
);

export const mapStateToProps = state => {
  const { _ } = state;
  return { _ };
};
export default connect(mapStateToProps)(Notifications);
